import Effects from 'effects/Effects.js';
import MultiFilter from "effects/MultiFilter.js";
import GainEffect from "effects/GainEffect.js";
import SoftClipper from 'effects/SoftClipper.js';
import Granulator from 'effects/Granulator.js';
import FreakShifter from 'effects/FreakShifter.js';
import AutoWahEffect from 'effects/AutoWah.js';
import Follower from 'effects/Follower.js';
import GeneticWaveShaper from 'effects/GeneticWaveShaper.js';
import VocoderEffect from 'effects/VocoderEffect.js';
import UltraPhaser from 'effects/UltraPhaser.js';
import PlaneParametersEffect from 'effects/midi/mappable/PlaneParametersEffect.js';
import RingModulator from 'effects/RingModulator.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ConvolverReverbEffect from 'effects/ConvolverReverbEffect.js';
import MultibandCompressor from 'effects/MultibandCompressor.js';
import Oscilloscope from 'effects/Oscilloscope.js';
import DelayEffect from 'effects/Delay.js';
import StereoWidener from 'effects/StereoWidener.js';
import EQ8 from 'effects/EQ8.js';
import WarpEffect from 'effects/midi/WarpEffect.js';
import AccumulatorEffect from 'effects/midi/mappable/AccumulatorEffect.js';
import ControlParametersEffect from 'effects/midi/mappable/ControlParametersEffect.js';
import PhaserEffect from 'effects/Phaser.js';
import CompressorEffect from 'effects/Compressor.js';
import DistortionEffect from 'effects/Distortion.js';
import GranularEffect from 'effects/GranularEffect.js';
import BitCrusherEffect from 'effects/BitCrusher.js';
import EQ3Effect from 'effects/EQ3.js';
import TransientShaper from 'effects/TransientShaper.js';
import AlternateTuningEffect from 'effects/midi/AlternateTuningEffect.js';
import EQ10Effect from 'effects/EQ10.js';
import GateEffect from 'effects/Gate.js';
import PitchShift from 'effects/PitchShift.js';
import Panner from 'effects/Panner.js';
import ArpEffect from 'effects/midi/ArpEffect.js';
import Chebyshev from 'effects/Chebyshev.js';
import Saturator from 'effects/Saturator.js';
import TapeDelay from 'effects/TapeDelay.js';
import StereoDelay from 'effects/StereoDelay.js';
import EffectRack from 'effects/rack/EffectRack.js';
import GuitarAmpEffect from 'effects/GuitarAmpEffect.js';
import WaveFolder from 'effects/WaveFolder.js';
import WaveFolder2 from 'effects/WaveFolder2.js';
import FrequencyShifter from 'effects/FrequencyShifter.js';
import MidiCCEffect from 'effects/midi/MidiCCEffect.js';
import HarmonyEffect from 'effects/midi/HarmonyEffect.js';
import EveryEffect from 'effects/midi/EveryEffect.js';
import ParameterEffect from 'effects/midi/ParameterEffect.js';
import TimingEffect from 'effects/midi/TimingEffect.js';
import MidiDelayEffect from 'effects/midi/MidiDelayEffect.js';
import ChordRhythmEffect from 'effects/midi/ChordRhythmEffect.js';
import ChordSculptorEffect from 'effects/midi/ChordSculptorEffect.js';
import MidiInterfaceEffect from 'effects/midi/MidiInterfaceEffect.js';
import RollEffect from 'effects/live/RollEffect.js';
import PaletteEffect from 'effects/live/PaletteEffect.js';
import MidiEffectRack from 'effects/midi/MidiEffectRack.js';
import MidiOutputter from 'effects/midi/MidiOutputter.js';
import TidalEffect from 'effects/midi/TidalEffect.js';
import LinkedTidal from 'effects/midi/LinkedTidal.js';
import LimitEffect from 'effects/midi/LimitEffect.js';
import BeatRepeat from 'effects/midi/scripting/BeatRepeat.js';
import BeatEffect from 'effects/midi/scripting/BeatEffect.js';
import MidiGateEffect from 'effects/midi/scripting/GateEffect.js';
import PatternSwitchEffect from 'effects/midi/scripting/PatternSwitchEffect.js';
import PolyEffect from 'effects/midi/scripting/PolyEffect.js';
import Steps from 'effects/midi/scripting/Steps.js';
import Notes from 'effects/midi/scripting/Notes.js';
import UserScriptEffect from 'effects/midi/scripting/UserScriptEffect.js';
import ThresholdEffect from 'effects/midi/scripting/ThresholdEffect.js';
import Grab from 'effects/midi/scripting/Grab.js';
import GrabTime from 'effects/midi/scripting/GrabTime.js';
import AltEffect from 'effects/midi/scripting/AltEffect.js';
import AltNEffect from 'effects/midi/scripting/AltNEffect.js';
import DensityEffect from 'effects/midi/scripting/DensityEffect.js';
import MicroTuningEffect from 'effects/midi/MicroTuningEffect.js';
import ScaleEffect from 'effects/midi/scales/ScaleEffect.js';
import Roll from 'effects/midi/scripting/Roll.js';
import NoteDisplay from 'effects/midi/NoteDisplayEffect.js';
import SparseEffect from 'effects/midi/SparseEffect.js';
import JakiEffect from 'effects/midi/jaki/JakiEffect.js';
import GenerativeChordsEffect from 'effects/midi/chords/GenerativeChordsEffect.js';
import StatsEffect from 'effects/midi/scripting/StatsEffect.js';
import ConditionalParametersEffect from 'effects/midi/mappable/ConditionalParametersEffect.js';
import Flush from 'effects/midi/messaging/Flush.js';
import Message from 'effects/midi/messaging/Message.js';
import {
    Figure,
    Max,
    First,
    Double,
    Regular,
    Skip,
    Later,
    REvery,
    Last,
    Dash1,
    Dash2,
    Dot,
    Accent,
    Staccato,
    Piano,
    Pianissimo,
    Legato,
    Rest} from 'effects/midi/jaki/RuleEffects.js';

export const effectOptions =  [
    {value: 'Bit Crusher', label:'Bit Crusher'},
//    {value: 'Chebyshev', label:'Chebyshev'},
    {value: 'Chorus', label:'Chorus'},
    {value: 'Compressor', label:'Compressor'},
    {value: 'Convolver Reverb', label:'Convolver Reverb'},
    {value: 'Delay', label:'Delay'},
    {value: 'Distortion', label:'Distortion'},
    {value: 'Effect Rack', label:'Effect Rack'},
    {value: 'EQ8', label:'EQ 8'},
    {value: 'Filter', label:'Filter'},
 //   {value: 'Follower', label:'Follower'},
    {value: 'Freak Shifter', label:'Freak Shifter'},
    {value: 'Frequency Shifter', label:'Frequency Shifter'},
    {value: 'Gain', label:'Gain'},
//    {value: 'Granulator', label:'Granulator'},
    {value: 'Guitar Amp', label:'Guitar Amp'},
  //  {value: 'Granular', label:'Granular'},
   // {value: 'Multiband Compressor', label:'Multiband Compressor'},
    {value: 'Multi Filter', label:'Multi Filter'},
    {value: 'Oscilloscope', label:'Oscilloscope'},
    {value: 'Panner', label:'Panner'},
    {value: 'Pitch Shift', label:'Pitch Shift'},
    {value: 'Phaser', label:'Phaser'},
   // {value: 'Ring Modulator', label:'Ring Modulator'},
    {value: 'Saturator', label:'Saturator'},
    {value: 'Soft Clipper', label:'Soft Clipper'},
    {value: 'Tape Delay', label:'Tape Delay'},
    {value: 'Transient Shaper', label:'Transient Shaper'},
    {value: 'Wave Folder', label:'Wave Folder'},
    //{value: 'Vocoder', label:'Vocoder'},
];

export function getEffectOptions(value) {
    var options = effectOptions.filter((opt) => opt.value === value);
    return options[0];
}

export function initializeEffect(name, sequencerEngine) {
    var effect = null;
    if (name === 'Filter') {
        effect = new Effects.FilterEffect(sequencerEngine);

    } else if (name === 'Reverb') {
        effect = new Effects.ReverbEffect(sequencerEngine);
    } else if (name === 'Convolver Reverb') {
        effect = new ConvolverReverbEffect(sequencerEngine);
    } else if (name === 'Delay') {
        effect = new DelayEffect(sequencerEngine);
    } else if (name === 'Chorus') {
        effect = new Effects.ChorusEffect(sequencerEngine);
    } else if (name === 'Gain') {
        effect = new GainEffect(sequencerEngine);
    } else if (name === 'Genetic WaveShaper') {
        effect = new GeneticWaveShaper(sequencerEngine);
    } else if (name === 'Tremolo') {
        effect = new Effects.TremoloEffect(sequencerEngine);
    } else if (name === 'Auto Filter') {
        effect = new Effects.AutoFilterEffect(sequencerEngine);
    } else if (name === 'Compressor') {
        effect = new CompressorEffect(sequencerEngine);
    } else if (name === 'Multi Filter') {
        effect = new MultiFilter(sequencerEngine);
    } else if (name === 'Multiband Compressor') {
        effect = new MultibandCompressor(sequencerEngine);
    } else if (name === 'Distortion') {
        effect = new DistortionEffect(sequencerEngine);
    } else if (name === 'Bit Crusher') {
        effect = new BitCrusherEffect(sequencerEngine);
    } else if (name === 'Guitar Amp') {
        effect = new GuitarAmpEffect(sequencerEngine);
    } else if (name === 'Granular') {
        effect = new GranularEffect(sequencerEngine);
    } else if (name === 'EQ 3') {
    } else if (name === 'EQ 3') {
        effect = new EQ3Effect(sequencerEngine);
    } else if (name === 'EQ 10') {
        effect = new EQ10Effect(sequencerEngine);
    } else if (name === 'Freak Shifter') {
        effect = new FreakShifter(sequencerEngine);
    } else if (name === 'Phaser') {
        effect = new UltraPhaser(sequencerEngine);
    } else if (name === 'Auto Wah') {
        effect = new AutoWahEffect(sequencerEngine);
    } else if (name === 'Gate') {
        effect = new GateEffect(sequencerEngine);
    } else if (name === 'Pitch Shift') {
        effect = new PitchShift(sequencerEngine);
    } else if (name === 'Panner') {
        effect = new Panner(sequencerEngine);
    } else if (name === 'EQ8') {
        effect = new EQ8(sequencerEngine);
    } else if (name === 'Chebyshev') {
        effect = new Chebyshev(sequencerEngine);
    } else if (name === 'Stereo Widener') {
        effect = new StereoWidener(sequencerEngine);
    } else if (name === 'Saturator') {
        effect = new Saturator(sequencerEngine);
    } else if (name === 'Soft Clipper') {
        effect = new SoftClipper(sequencerEngine);
    } else if (name === 'Tape Delay') {
        effect = new TapeDelay(sequencerEngine);
    } else if (name === 'Stereo Delay') {
        effect = new StereoDelay(sequencerEngine);
    } else if (name === 'Oscilloscope') {
        effect = new Oscilloscope(sequencerEngine);
    } else if (name === 'Effect Rack') {
        effect = new EffectRack(sequencerEngine);
    } else if (name === 'Wave Folder') {
        effect = new WaveFolder(sequencerEngine);
    } else if (name === 'Granulator') {
        effect = new Granulator(sequencerEngine);
    } else if (name === 'Ring Modulator') {
        effect = new RingModulator(sequencerEngine);
    } else if (name === 'Follower') {
        effect = new Follower(sequencerEngine);
    } else if (name === 'Vocoder') {
        effect = new VocoderEffect(sequencerEngine);
    } else if (name === 'Frequency Shifter') {
        effect = new FrequencyShifter(sequencerEngine);
    } else if (name === 'Transient Shaper') {
        effect = new TransientShaper(sequencerEngine);
    }
    
    effect.toggle();
    return effect;
}

export const ruleEffectOptions = [
    {value: 'Accent', label:'Accent'},
    {value: 'Dot', label:'Dot'},
    {value: 'Dash 1', label:'Dash 1'},
    {value: 'Dash 2', label:'Dash 2'},
    {value: 'Otherwise', label:'Otherwise'},
    {value: 'Piano', label:'Piano'},
    {value: 'Pianissimo', label:'Pianissimo'},
    {value: 'Rest', label:'Rest'},
    {value: 'Staccato', label:'Staccato'},
];

export const ruleAuxOptions = [
    {value: 'Regular', label:'Regular'},
    {value: 'Double', label:'Double'},
    {value: 'R.Every', label:'Every'},
    {value: 'Figure', label:'Figure'},
    {value: 'First', label:'First'},
    {value: 'Last', label:'Last'},
    {value: 'Later', label:'Later'},
    {value: 'Max', label:'Max'},
    {value: 'Skip', label:'Skip'},
];


export const midiEffectOptions = [
    {value: 'Accumulator Effect', label:'Accumulator Effect'},
    {value: 'Arpeggiator', label:'Arpeggiator'},
    {value: 'Chord Rhythm', label:'Chord Rhythm'},
    {value: 'Conditional Parameters', label:'Conditional Parameters'},
    {value: 'Control Parameters', label:'Control Parameters'},
    {value: 'Midi Delay', label:'Delay'},
    {value: 'Every', label:'Every'},
    {value: 'Gate', label:'Gate'},
    {value: 'Generative Chords', label:'Generative Chords'},
    {value: 'Grab', label:'Grab'},
    {value: 'Grab Time', label:'Grab Time'},
    {value: 'Harmony', label:'Harmony'},
    {value: 'Jaki', label:'Jaki'},
    {value: 'Linked Tidal', label:'Linked Tidal'},
    {value: 'Midi CC', label:'Midi CC'},
    {value: 'Midi Effect Rack', label:'Midi Effect Rack'},
    {value: 'Note Display', label:'Note Display'},
    {value: 'Plane Parameters', label:'Plane Parameters'},
    {value: 'Parametizer', label:'Parametizer'},
    {value: 'Scale', label:'Scale'},
    {value: 'User Script', label:'Script'},
    {value: 'Sparse', label:'Sparse'},
    {value: 'Stats', label:'Stats'},
    {value: 'Tidal', label:'Tidal'},
    {value: 'Timing', label:'Timing'},
    {value: 'Warp', label:'Warp'},
];

export const midiConditionalOptions = [
    {value: 'Alternate', label:'Alternate'},
    {value: 'Alternate N', label:'Alternate N'},
    //{value: 'Beat', label: 'Beat'},
    {value: 'Limit', label:'Limit'},
    {value: 'Midi Outputter', label:'Midi Outputter'},
    {value: 'Pattern Switch', label:'Pattern Switch'},
    //{value: 'Poly', label:'Poly'},
    {value: 'Roll', label:'Rolling'},
    //{value: 'Threshold', label:'Threshold'},
];

export function getMidiEffectOptions(value) {
    var options = midiEffectOptions.filter((opt) => opt.value === value);
    return options[0];
}

export const initializeMidiEffect = (name, track) => {
    var effect = null;

    if (name === 'Arpeggiator') {
        effect = new ArpEffect(track);
    } else if (name === 'Parametizer') {
        effect = new ParameterEffect(track);
    } else if (name === 'Harmony') {
        effect = new HarmonyEffect(track);
    } else if (name === 'Every') {
        effect = new EveryEffect(track);
    } else if (name === 'Timing') {
        effect = new TimingEffect(track);
    } else if (name === 'Midi Outputter') {
        effect = new MidiOutputter(track);
    } else if (name === 'Midi Interface') {
        effect = new MidiInterfaceEffect(track);
    } else if (name === 'Alternate Tuning') {
        effect = new AlternateTuningEffect(track);
    } else if (name === 'Warp') {
        effect = new WarpEffect(track);
    } else if (name === 'Midi Delay') {
        effect = new MidiDelayEffect(track);
    } else if (name === 'Chord Rhythm') {
        effect = new ChordRhythmEffect(track);
    } else if (name === 'Chord Sculptor') {
        effect = new ChordSculptorEffect(track);
    } else if (name === 'Tidal') {
        effect = new TidalEffect(track);
    } else if (name === 'Flush') {
        effect = new Flush(track);
    } else if (name === 'Message') {
        effect = new Message(track);
    } else if (name === 'Midi Effect Rack') {
        effect = new MidiEffectRack(track);
    } else if (name === 'Limit') {
        effect = new LimitEffect(track);
    } else if (name === 'Beat Repeat') {
        effect = new BeatRepeat(track);
    } else if (name === 'Steps') {
        effect = new Steps(track);
    } else if (name === 'Notes') {
        effect = new Notes(track);
    } else if (name === 'User Script') {
        effect = new UserScriptEffect(track);
    } else if (name === 'Grab') {
        effect = new Grab(track);
    } else if (name === 'Gate') {
        effect = new MidiGateEffect(track);
    } else if (name === 'Roll') {
        effect = new Roll(track);
    } else if (name === 'Grab Time') {
        effect = new GrabTime(track);
    } else if (name === 'Alternate') {
        effect = new AltEffect(track);
    } else if (name === 'Alternate N') {
        effect = new AltNEffect(track);
    } else if (name === 'Density') {
        effect = new DensityEffect(track);
    } else if (name === 'Threshold') {
        effect = new ThresholdEffect(track);
    } else if (name === 'Midi CC') {
        effect = new MidiCCEffect(track);
    } else if (name === 'Accumulator Effect') {
        effect = new AccumulatorEffect(track);
    } else if (name === 'Control Parameters') {
        effect = new ControlParametersEffect(track);
    } else if (name === 'Conditional Parameters') {
        effect = new ConditionalParametersEffect(track);
    } else if (name === 'Plane Parameters') {
        effect = new PlaneParametersEffect(track);
    } else if (name === 'Micro Tuning') {
        effect = new MicroTuningEffect(track);
    } else if (name === 'Scale') {
        effect = new ScaleEffect(track);
    } else if (name === 'Beat') {
        effect = new BeatEffect(track);
    } else if (name === 'Pattern Switch') {
        effect = new PatternSwitchEffect(track);
    } else if (name === 'Poly') {
        effect = new PolyEffect(track);
    } else if (name === 'Linked Tidal') {
        effect = new LinkedTidal(track);
    } else if (name === 'Note Display') {
        effect = new NoteDisplay(track);
    } else if (name === 'Sparse') {
        effect = new SparseEffect(track);
    } else if (name === 'Stats') {
        effect = new StatsEffect(track);
    } else if (name === 'Jaki') {
        effect = new JakiEffect(track);
    } else if (name === 'Accent') {
        effect = new Accent(track);
    } else if (name === 'Regular') {
        effect = new Regular(track);
    } else if (name === 'Staccato') {
        effect = new Staccato(track);
    } else if (name === 'Rest') {
        effect = new Rest(track);
    } else if (name === 'Piano') {
        effect = new Piano(track);
    } else if (name === 'Pianissimo') {
        effect = new Pianissimo(track);
    } else if (name === 'Dot') {
        effect = new Dot(track);
    } else if (name === 'Dash 1') {
        effect = new Dash1(track);
    } else if (name === 'Dash 2') {
        effect = new Dash2(track);
    } else if (name === 'Max') {
        effect = new Max(track);
    } else if (name === 'Figure') {
        effect = new Figure(track);
    } else if (name === 'First') {
        effect = new First(track);
    } else if (name === 'R.Every') {
        effect = new REvery(track);
    } else if (name === 'Last') {
        effect = new Last(track);
    } else if (name === 'Legato') {
        effect = new Legato(track);
    } else if (name === 'Double') {
        effect = new Double(track);
    } else if (name === 'Later') {
        effect = new Later(track);
    } else if (name === 'Skip') {
        effect = new Skip(track);
    } else if (name === 'Generative Chords') {
        effect = new GenerativeChordsEffect(track);
    }

    return effect;
}
